export default function createInviteLink(teamId) {
    var url = `${window.location.hostname}`;
    if (window.location.port) {
        url = `${url}:${window.location.port}`;
    }
    return `${url}/invite/${teamId}`;
}
